import React, { useState } from "react";
import "../../css/MainPage/ContactUs.css";
import facebookIcon from "../../assets/Icons/facebook-black.png";
import instagramIcon from "../../assets/Icons/instagram-black.png";
import tiktokIcon from "../../assets/Icons/tiktok-black.png";
import linkedinIcon from "../../assets/Icons/linkedin-black.png";
import FormGroup from "../../components/FormGroup";
import InputField from "../../components/InputField";
import SubmitButton from "../../components/SubmitButton";

const CONTACTUS_URL = process.env.REACT_APP_CONTACTUS_URL;
const CONTACTUS_EMAIL_KEY = process.env.REACT_APP_CONTACTUS_EMAIL_KEY;

function ContactUs() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    university: "",
    major: "",
    subject: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const formData = new FormData(event.target);
    formData.append("access_key", CONTACTUS_EMAIL_KEY);

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const response = await fetch(CONTACTUS_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      });

      const res = await response.json();

      if (res.success) {
        setIsSubmitted(true);
        setErrorMessage(""); // Clear any previous error message
      } else {
        throw new Error(res.message || "Failed to submit form");
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      setErrorMessage(
        "There was an error submitting the form. Please try again later."
      );
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  return (
    <div id="contact-body">
      <div className="contact-container">
        {isSubmitted ? (
          <p className="successMessage">
            Thank you for your message! We will get back to you soon.
          </p>
        ) : (
          <>
            <h1 className="title">Contact Us</h1>
            <p className="introText">
              We'd love to hear from you! Whether you have questions, feedback,
              or need assistance, feel free to reach out to us through any of
              the following methods.
            </p>

            <h2 className="subTitle">Get in Touch</h2>
            <p className="contactInfo">
              Email:{" "}
              <a className="link" href="mailto:collegenav.info@gmail.com">
                collegenav.info@gmail.com
              </a>
            </p>

            <h2 className="subTitle">Contact Form</h2>

            <form className="form" onSubmit={onSubmit}>
              <FormGroup inline>
                <InputField
                  type="text"
                  name="first_name"
                  label="First Name"
                  value={formValues.first_name}
                  onChange={handleInputChange}
                  required
                />
                <InputField
                  type="text"
                  name="last_name"
                  label="Last Name"
                  value={formValues.last_name}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <InputField
                  type="email"
                  name="email"
                  label="Email Address"
                  value={formValues.email}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <InputField
                  type="text"
                  name="university"
                  label="University Name"
                  value={formValues.university}
                  onChange={handleInputChange}
                />
              </FormGroup>

              <FormGroup>
                <InputField
                  type="text"
                  name="major"
                  label="Major"
                  value={formValues.major}
                  onChange={handleInputChange}
                />
              </FormGroup>

              <FormGroup>
                <InputField
                  type="text"
                  name="subject"
                  label="Subject of the Message"
                  value={formValues.subject}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <InputField
                  type="textarea"
                  name="message"
                  label="Message"
                  value={formValues.message}
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>

              <SubmitButton
                text="Send Message"
                loadingText="Sending..."
                isLoading={isLoading}
                disabled={isLoading}
              />

              {errorMessage && <p className="error">{errorMessage}</p>}
            </form>

            <h2 className="subTitle">Social Media</h2>
            <p className="introText">Stay connected with us on social media:</p>
            <ul className="socialMediaList">
              <li className="footer-category-item">
                <a
                  className="socialMediaLink"
                  href="https://www.linkedin.com/company/college-nav/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="footer-category-pic"
                    src={linkedinIcon}
                    alt="Linked In"
                  />
                </a>
              </li>
              <li className="footer-category-item">
                <a
                  className="socialMediaLink"
                  href="https://www.facebook.com/people/Collegenavinfo/61565326201320/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="footer-category-pic"
                    src={facebookIcon}
                    alt="Facebook"
                  />
                </a>
              </li>
              <li className="footer-category-item">
                <a
                  className="socialMediaLink"
                  href="https://www.instagram.com/collegenav.info/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="footer-category-pic"
                    src={instagramIcon}
                    alt="Instagram"
                  />
                </a>
              </li>
              <li className="footer-category-item">
                <a
                  className="socialMediaLink"
                  href="https://www.tiktok.com/@collegenav"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="footer-category-pic"
                    src={tiktokIcon}
                    alt="TikTok"
                  />
                </a>
              </li>
            </ul>

            {/* <h2 className="subTitle">FAQs</h2>
            <p className="introText">
              Check out our{" "}
              <a className="faqLink" href="#">
                FAQs page
              </a>{" "}
              for answers to common questions. If you don't find what you're
              looking for, don't hesitate to reach out.
            </p>

            <h2 className="subTitle">Help Center</h2>
            <p className="introText">
              For immediate assistance, visit our{" "}
              <a className="helpCenterLink" href="#">
                Help Center
              </a>{" "}
              for resources and support.
            </p>

            <p className="introText">We look forward to assisting you!</p> */}
          </>
        )}
      </div>
    </div>
  );
}

export default ContactUs;
